import Settings from "../assets/settings.svg";
import Documents from "../assets/documents.svg";
import SolarDocuments from "../assets/solar_documents.svg";
import chart from "../assets/chart.svg";
import settingsRed from "../assets/settings-red.svg";
import DocumentsRed from "../assets/documents-red.svg";
import SolarDocumentsRed from "../assets/solar-red.svg";
import chartRed from "../assets/chart-red.svg";
import SocialIcons1 from "../assets/Social icons1.png";
import SocialIcons3 from "../assets/Social icons3.png";
import SocialIcons4 from "../assets/Social icons4.png";
import SocialIcons5 from "../assets/Social icons5.png";
import SocialIcons6 from "../assets/youtube.png";

export const sidebarLinks = [
  {
    imgURL: chart,
    route: "/assigned-candidates",
    label: "Assigned Candidates",
    isActive: chartRed,
  },
  {
    imgURL: SolarDocuments,
    route: "/refine-resume",
    label: "Refine Resume",
    isActive: SolarDocumentsRed,
  },
  {
    imgURL: Documents,
    route: "/craft-sop",
    label: "Craft SOPs",
    isActive: DocumentsRed,
  },
  {
    imgURL: Settings,
    route: "/profile",
    label: "Profile",
    isActive: settingsRed,
  },
];

export const businessLinks = [
  {
    url: "https://proconnectpay.com/blog",
    name: "Blog",
  },
  {
    url: "https://proconnectpay.com/pricing",
    name: "Service Fee Pricing",
  },
  {
    url: "https://proconnectpay.com/supported-schools",
    name: "List of Supported Schools",
  },
  {
    url: "https://proconnectpay.com/interest",
    name: "Signify your interest",
  },
  {
    url: "https://proconnectpay.com/faqs",
    name: "FAQs",
  },
  {
    url: "https://proconnectpay.com/global-financing",
    name: "Global Financing",
  },
  {
    url: "https://proconnectpay.com/privacy-policy",
    name: "Privacy Policy",
  },
  {
    url: "https://proconnectpay.com/university-admission",
    name: "University Admission",
  },
  {
    url: "https://proconnectpay.com/calculator",
    name: "Use our Calculator",
  },
  {
    url: "https://proconnectpay.com/nelfund-financing",
    name: "Nelfund Financing",
  },
];

export const locationLinks = [
  {
    url: "https://proconnectpay.com/contact",
    name: "Global HQ US",
  },
  {
    url: "https://proconnectpay.com/contact",
    name: "Africa HQ Lagos",
  },
  {
    url: "https://proconnectpay.com/contact",
    name: "Accra Office",
  },
  {
    url: "https://proconnectpay.com/contact",
    name: "Kampala Office",
  },
  {
    url: "https://proconnectpay.com/contact",
    name: "Nairobi Office",
  },
  {
    url: "https://proconnectpay.com/contact",
    name: "Kigali Office",
  },
  {
    url: "https://proconnectpay.com/contact",
    name: "Toronto Office",
  },
];

export const bankPartners = [
  {
    url: "https://proconnectpay.com/banks/union",
    name: "Union Bank",
  },
  {
    url: "https://proconnectpay.com/banks/wema",
    name: "Wema Bank",
  },
  {
    url: "https://proconnectpay.com/banks/ecobank",
    name: "EcoBank",
  },
  {
    url: "https://proconnectpay.com/banks/sycamore",
    name: "Sycamore",
  },
  {
    url: "https://proconnectpay.com/banks/polaris",
    name: "Polaris Bank",
  },
  {
    url: "https://proconnectpay.com/banks/nim",
    name: "Nigerian Institute of Management",
  },
];

export const socialIcons = [
  { name: SocialIcons1, url: "https://web.facebook.com/proconnectpay" },
  { name: SocialIcons3, url: "https://twitter.com/ProconnectPAY" },
  { name: SocialIcons4, url: "https://www.instagram.com/proconnectpay/" },
  { name: SocialIcons5, url: "https://ng.linkedin.com/company/proconnectpay" },
  {
    name: SocialIcons6,
    url: "https://www.youtube.com/channel/UCsX-weJpSWORcMUAQ-g0HdA",
  },
];

export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];

export const degreeOptions = [
  "Bachelor of Science (BSC)",
  "Bachelor of Arts (B.A)",
  "Bachelor of Dental Surgery",
  "Bachelor of Engineering (B.ENG)",
  "Bachelor of Education (B.ED)",
  "Bachelor of Medicine and Bachelor of Surgery (MBBS)",
  "Bachelor in Law (LLB)",
  "Bachelor of Pharmacy",
  "Bachelor of Nursing",
  "Bachelor of Medical Laboratory Science",
  "Bachelor of Technology",
  "Bachelor of Agriculture",
  "Master of Science (MSC)",
  "Master of Arts (MA)",
  "Master of Business Administration (MBA)",
  "Master of Engineering (M.ENG)",
  "Master of Law (LLM)",
  "Master of Education (M.ED)",
  "Master of Pharmacy",
  "Master of Nursing",
  "Master of Medical Laboratory Science",
  "Master of Technology",
  "Higher National Diploma",
  "Ordinary National Diploma",
  "Doctor of Optometry",
  "Doctor of Pharmacy",
  "Doctor of Veterinary Medicine"
];

export const countryOptions = [
  "Australia",
  "Belgium",
  "Canada",
  "China",
  "Denmark",
  "France",
  "Germany",
  "Hong Kong",
  "Italy",
  "Netherlands",
  "Nigeria",
  "Portugal",
  "Singapore",
  "South Africa",
  "Spain",
  "Switzerland",
  "United States",
  "United Kingdom",
];

export const programTypes = ["MSC", "MBA", "MPH", "MENG", "LLM", "MA", "MREs"];

export const sessionTimelineOptions = [
  {
    value: "Summer (May/June) 2025",
    label: "Summer (May/June) 2025",
    year: "2025/2026",
  },
  {
    value: "Fall (September) 2025",
    label: "Fall (September) 2025",
    year: "2025/2026",
  },
  {
    value: "Spring (Between Jan-Mar) 2026",
    label: "Spring (Between Jan-Mar) 2026",
    year: "2026/2027",
  },
  {
    value: "Summer (May/June) 2026",
    label: "Summer (May/June) 2026",
    year: "2026/2027",
  },
  {
    value: "Fall (September) 2026",
    label: "Fall (September) 2026",
    year: "2026/2027",
  },
  {
    value: "Spring (Between Jan-Mar) 2027",
    label: "Spring (Between Jan-Mar) 2027",
    year: "2027/2028",
  },
  {
    value: "Summer (May/June) 2027",
    label: "Summer (May/June) 2027",
    year: "2027/2028",
  },
  {
    value: "Fall (September) 2027",
    label: "Fall (September) 2027",
    year: "2027/2028",
  },
  {
    value: "Spring (Between Jan-Mar) 2028",
    label: "Spring (Between Jan-Mar) 2028",
    year: "2028/2029",
  },
  {
    value: "Summer (May/June) 2028",
    label: "Summer (May/June) 2028",
    year: "2028/2029",
  },
  {
    value: "Fall (September) 2028",
    label: "Fall (September) 2028",
    year: "2028/2029",
  },
  {
    value: "Spring (Between Jan-Mar) 2029",
    label: "Spring (Between Jan-Mar) 2029",
    year: "2029/2030",
  },
  {
    value: "Summer (May/June) 2029",
    label: "Summer (May/June) 2029",
    year: "2029/2030",
  },
];

export const countriesData = [
  { country: "Afghanistan", demonym: "Afghan" },
  { country: "Albania", demonym: "Albanian" },
  { country: "Algeria", demonym: "Algerian" },
  { country: "Andorra", demonym: "Andorran" },
  { country: "Angola", demonym: "Angolan" },
  { country: "Antigua and Barbuda", demonym: "Antiguan or Barbudan" },
  { country: "Argentina", demonym: "Argentinian" },
  { country: "Armenia", demonym: "Armenian" },
  { country: "Australia", demonym: "Australian" },
  { country: "Austria", demonym: "Austrian" },
  { country: "Azerbaijan", demonym: "Azerbaijani" },
  { country: "Bahamas", demonym: "Bahamian" },
  { country: "Bahrain", demonym: "Bahraini" },
  { country: "Bangladesh", demonym: "Bangladeshi" },
  { country: "Barbados", demonym: "Barbadian" },
  { country: "Belarus", demonym: "Belarusian" },
  { country: "Belgium", demonym: "Belgian" },
  { country: "Belize", demonym: "Belizean" },
  { country: "Benin", demonym: "Beninese" },
  { country: "Bhutan", demonym: "Bhutanese" },
  { country: "Bolivia", demonym: "Bolivian" },
  { country: "Bosnia and Herzegovina", demonym: "Bosnian" },
  { country: "Botswana", demonym: "Botswanan" },
  { country: "Brazil", demonym: "Brazilian" },
  { country: "Brunei", demonym: "Bruneian" },
  { country: "Bulgaria", demonym: "Bulgarian" },
  { country: "Burkina Faso", demonym: "Burkinabé" },
  { country: "Burundi", demonym: "Burundian" },
  { country: "Cabo Verde", demonym: "Cape Verdean" },
  { country: "Cambodia", demonym: "Cambodian" },
  { country: "Cameroon", demonym: "Cameroonian" },
  { country: "Canada", demonym: "Canadian" },
  { country: "Central African Republic", demonym: "Central African" },
  { country: "Chad", demonym: "Chadian" },
  { country: "Chile", demonym: "Chilean" },
  { country: "China", demonym: "Chinese" },
  { country: "Colombia", demonym: "Colombian" },
  { country: "Comoros", demonym: "Comorian" },
  { country: "Congo, Republic of the", demonym: "Congolese" },
  { country: "Congo, Democratic Republic of the", demonym: "Congolese" },
  { country: "Costa Rica", demonym: "Costa Rican" },
  { country: "Croatia", demonym: "Croatian" },
  { country: "Cuba", demonym: "Cuban" },
  { country: "Cyprus", demonym: "Cypriot" },
  { country: "Czech Republic", demonym: "Czech" },
  { country: "Denmark", demonym: "Danish" },
  { country: "Djibouti", demonym: "Djiboutian" },
  { country: "Dominica", demonym: "Dominican" },
  { country: "Dominican Republic", demonym: "Dominican" },
  { country: "Ecuador", demonym: "Ecuadorian" },
  { country: "Egypt", demonym: "Egyptian" },
  { country: "El Salvador", demonym: "Salvadoran" },
  { country: "Equatorial Guinea", demonym: "Equatoguinean" },
  { country: "Eritrea", demonym: "Eritrean" },
  { country: "Estonia", demonym: "Estonian" },
  { country: "Eswatini", demonym: "Swazi" },
  { country: "Ethiopia", demonym: "Ethiopian" },
  { country: "Fiji", demonym: "Fijian" },
  { country: "Finland", demonym: "Finnish" },
  { country: "France", demonym: "French" },
  { country: "Gabon", demonym: "Gabonese" },
  { country: "Gambia", demonym: "Gambian" },
  { country: "Georgia", demonym: "Georgian" },
  { country: "Germany", demonym: "German" },
  { country: "Ghana", demonym: "Ghanaian" },
  { country: "Greece", demonym: "Greek" },
  { country: "Grenada", demonym: "Grenadian" },
  { country: "Guatemala", demonym: "Guatemalan" },
  { country: "Guinea", demonym: "Guinean" },
  { country: "Guinea-Bissau", demonym: "Guinea-Bissauan" },
  { country: "Guyana", demonym: "Guyanese" },
  { country: "Haiti", demonym: "Haitian" },
  { country: "Honduras", demonym: "Honduran" },
  { country: "Hungary", demonym: "Hungarian" },
  { country: "Iceland", demonym: "Icelander" },
  { country: "India", demonym: "Indian" },
  { country: "Indonesia", demonym: "Indonesian" },
  { country: "Iran", demonym: "Iranian" },
  { country: "Iraq", demonym: "Iraqi" },
  { country: "Ireland", demonym: "Irish" },
  { country: "Israel", demonym: "Israeli" },
  { country: "Italy", demonym: "Italian" },
  { country: "Jamaica", demonym: "Jamaican" },
  { country: "Japan", demonym: "Japanese" },
  { country: "Jordan", demonym: "Jordanian" },
  { country: "Kazakhstan", demonym: "Kazakhstani" },
  { country: "Kenya", demonym: "Kenyan" },
  { country: "Kiribati", demonym: "I-Kiribati" },
  { country: "Kuwait", demonym: "Kuwaiti" },
  { country: "Kyrgyzstan", demonym: "Kyrgyz" },
  { country: "Laos", demonym: "Laotian" },
  { country: "Latvia", demonym: "Latvian" },
  { country: "Lebanon", demonym: "Lebanese" },
  { country: "Lesotho", demonym: "Basotho" },
  { country: "Liberia", demonym: "Liberian" },
  { country: "Libya", demonym: "Libyan" },
  { country: "Liechtenstein", demonym: "Liechtensteiner" },
  { country: "Lithuania", demonym: "Lithuanian" },
  { country: "Luxembourg", demonym: "Luxembourger" },
  { country: "Madagascar", demonym: "Malagasy" },
  { country: "Malawi", demonym: "Malawian" },
  { country: "Malaysia", demonym: "Malaysian" },
  { country: "Maldives", demonym: "Maldivian" },
  { country: "Mali", demonym: "Malian" },
  { country: "Malta", demonym: "Maltese" },
  { country: "Marshall Islands", demonym: "Marshallese" },
  { country: "Mauritania", demonym: "Mauritanian" },
  { country: "Mauritius", demonym: "Mauritian" },
  { country: "Mexico", demonym: "Mexican" },
  { country: "Micronesia", demonym: "Micronesian" },
  { country: "Moldova", demonym: "Moldovan" },
  { country: "Monaco", demonym: "Monacan" },
  { country: "Mongolia", demonym: "Mongolian" },
  { country: "Montenegro", demonym: "Montenegrin" },
  { country: "Morocco", demonym: "Moroccan" },
  { country: "Mozambique", demonym: "Mozambican" },
  { country: "Myanmar", demonym: "Burmese" },
  { country: "Namibia", demonym: "Namibian" },
  { country: "Nauru", demonym: "Nauruan" },
  { country: "Nepal", demonym: "Nepalese" },
  { country: "Netherlands", demonym: "Dutch" },
  { country: "New Zealand", demonym: "New Zealander" },
  { country: "Nicaragua", demonym: "Nicaraguan" },
  { country: "Niger", demonym: "Nigerien" },
  { country: "Nigeria", demonym: "Nigerian" },
  { country: "North Macedonia", demonym: "Macedonian" },
  { country: "Norway", demonym: "Norwegian" },
  { country: "Oman", demonym: "Omani" },
  { country: "Pakistan", demonym: "Pakistani" },
  { country: "Palau", demonym: "Palauan" },
  { country: "Palestine", demonym: "Palestinian" },
  { country: "Panama", demonym: "Panamanian" },
  { country: "Papua New Guinea", demonym: "Papua New Guinean" },
  { country: "Paraguay", demonym: "Paraguayan" },
  { country: "Peru", demonym: "Peruvian" },
  { country: "Philippines", demonym: "Filipino" },
  { country: "Poland", demonym: "Polish" },
  { country: "Portugal", demonym: "Portuguese" },
  { country: "Qatar", demonym: "Qatari" },
  { country: "Romania", demonym: "Romanian" },
  { country: "Russia", demonym: "Russian" },
  { country: "Rwanda", demonym: "Rwandan" },
  { country: "Saint Kitts and Nevis", demonym: "Kittitian or Nevisian" },
  { country: "Saint Lucia", demonym: "Saint Lucian" },
  { country: "Saint Vincent and the Grenadines", demonym: "Saint Vincentian" },
  { country: "Samoa", demonym: "Samoan" },
  { country: "San Marino", demonym: "Sammarinese" },
  { country: "Sao Tome and Principe", demonym: "Sao Tomean" },
  { country: "Saudi Arabia", demonym: "Saudi" },
  { country: "Senegal", demonym: "Senegalese" },
  { country: "Serbia", demonym: "Serbian" },
  { country: "Seychelles", demonym: "Seychellois" },
  { country: "Sierra Leone", demonym: "Sierra Leonean" },
  { country: "Singapore", demonym: "Singaporean" },
  { country: "Slovakia", demonym: "Slovak" },
  { country: "Slovenia", demonym: "Slovenian" },
  { country: "Solomon Islands", demonym: "Solomon Islander" },
  { country: "Somalia", demonym: "Somali" },
  { country: "South Africa", demonym: "South African" },
  { country: "South Korea", demonym: "South Korean" },
  { country: "South Sudan", demonym: "South Sudanese" },
  { country: "Spain", demonym: "Spanish" },
  { country: "Sri Lanka", demonym: "Sri Lankan" },
  { country: "Sudan", demonym: "Sudanese" },
  { country: "Suriname", demonym: "Surinamese" },
  { country: "Sweden", demonym: "Swedish" },
  { country: "Switzerland", demonym: "Swiss" },
  { country: "Syria", demonym: "Syrian" },
  { country: "Taiwan", demonym: "Taiwanese" },
  { country: "Tajikistan", demonym: "Tajik" },
  { country: "Tanzania", demonym: "Tanzanian" },
  { country: "Thailand", demonym: "Thai" },
  { country: "Togo", demonym: "Togolese" },
  { country: "Tonga", demonym: "Tongan" },
  { country: "Trinidad and Tobago", demonym: "Trinidadian or Tobagonian" },
  { country: "Tunisia", demonym: "Tunisian" },
  { country: "Turkey", demonym: "Turkish" },
  { country: "Turkmenistan", demonym: "Turkmen" },
  { country: "Tuvalu", demonym: "Tuvaluan" },
  { country: "Uganda", demonym: "Ugandan" },
  { country: "Ukraine", demonym: "Ukrainian" },
  { country: "United Arab Emirates", demonym: "Emirati" },
  { country: "United Kingdom", demonym: "British" },
  { country: "United States", demonym: "American" },
  { country: "Uruguay", demonym: "Uruguayan" },
  { country: "Uzbekistan", demonym: "Uzbek" },
  { country: "Vanuatu", demonym: "Ni-Vanuatu" },
  { country: "Vatican City", demonym: "Vatican" },
  { country: "Venezuela", demonym: "Venezuelan" },
  { country: "Vietnam", demonym: "Vietnamese" },
  { country: "Yemen", demonym: "Yemeni" },
  { country: "Zambia", demonym: "Zambian" },
  { country: "Zimbabwe", demonym: "Zimbabwean" },
];

const supportedSchools = [
  { id: 0, name: "Carl von Ossietzky Universitat Oldenburg" },
  { id: 1, name: "Constructor University" },
  { id: 900, name: "University of Roehampton" },
  { id: 2, name: "ESMT Berlin" },
  { id: 3, name: "Frankfurt School of Finance and Management" },
  { id: 4, name: "Hamburg University of Technology" },
  { id: 5, name: "HHL Leipzig" },
  { id: 6, name: "Mannheim Business School" },
  { id: 7, name: "Technical University of Munich" },
  { id: 8, name: "WHU - Otto Beisheim" },
  { id: 0, name: "Australian Catholic University" },
  { id: 1, name: "Australian National University" },
  { id: 2, name: "Charles Sturt University" },
  { id: 3, name: "Deakin University" },
  { id: 4, name: "Edith Cowan University" },
  { id: 5, name: "Griffith University" },
  { id: 6, name: "James Cook University" },
  { id: 7, name: "Macquarie University" },
  { id: 8, name: "Monash University" },
  { id: 9, name: "Queensland University of Technology" },
  { id: 10, name: "Swinburne University of Technology" },
  { id: 11, name: "University of Canberra" },
  { id: 12, name: "University of New England - Australia" },
  { id: 13, name: "University of Sydney" },
  { id: 14, name: "University of Tasmania" },
  { id: 15, name: "University of Technology Sydney" },
  { id: 16, name: "University of Western Australia" },
  { id: 17, name: "University of Wollongong" },
  { id: 18, name: "Western Sydney University" },
  { id: 0, name: "Nanyang Technological University" },
  { id: 1, name: "National University of Singapore" },
  { id: 0, name: "The Lisbon MBA" },
  { id: 1, name: "University of Porto" },
  { id: 0, name: "POLIMI Graduate School of Management" },
  { id: 1, name: "SDA Bocconi School of Management" },
  { id: 0, name: "Chinese University of Hong Kong" },
  { id: 1, name: "Hong Kong University of Science and Technology" },
  { id: 2, name: "University of Hong Kong" },
  { id: 0, name: "EADA Business School" },
  { id: 1, name: "Ramon Llull University" },
  { id: 2, name: "University of Navarra" },
  { id: 0, name: "Copenhagen Business School" },
  { id: 0, name: "China Europe International Business School" },
  { id: 1, name: "Fudan University" },
  { id: 2, name: "Shanghai Jiao Tong University" },
  { id: 0, name: "IMD Business School" },
  { id: 0, name: "Antwerp Management School" },
  { id: 1, name: "Vlerick Business School" },
  { id: 0, name: "University of Cape Town" },
  { id: 0, name: "Audencia Business School" },
  { id: 1, name: "Burgundy School of Business" },
  { id: 2, name: "Ecole Polytechnique" },
  { id: 3, name: "EDHEC Business School" },
  { id: 4, name: "EM Normandie Business School" },
  { id: 5, name: "Emlyon" },
  { id: 6, name: "ESCP Europe Business School" },
  { id: 7, name: "ESSEC Business School" },
  { id: 8, name: "Grenoble Ecole de Management" },
  { id: 9, name: "HEC Paris" },
  { id: 10, name: "IESEG" },
  { id: 11, name: "INSEAD" },
  { id: 12, name: "Kedge Business School" },
  { id: 13, name: "Montpellier Business School" },
  { id: 14, name: "Neoma Business School" },
  { id: 15, name: "Paris School of Business" },
  { id: 16, name: "Rennes School of Business" },
  { id: 17, name: "SKEMA Business School" },
  { id: 0, name: "Aberystwyth University" },
  { id: 1, name: "Anglia Ruskin University" },
  { id: 2, name: "Aston University" },
  { id: 3, name: "Bangor University" },
  { id: 4, name: "Birkbeck University of London" },
  { id: 5, name: "Bournemouth University" },
  { id: 6, name: "Brunel University" },
  { id: 7, name: "Cardiff University" },
  { id: 8, name: "City, University of London" },
  { id: 9, name: "Coventry University" },
  { id: 10, name: "Cranfield University" },
  { id: 11, name: "De Montfort University" },
  { id: 12, name: "Durham University" },
  { id: 13, name: "Edinburgh Napier University" },
  { id: 14, name: "Glasgow Caledonian University" },
  { id: 15, name: "Goldsmiths University of London" },
  { id: 16, name: "Henley Business School" },
  { id: 17, name: "Imperial College London" },
  { id: 18, name: "Keele University" },
  { id: 19, name: "King's College London" },
  { id: 20, name: "Kingston University" },
  { id: 21, name: "Lancaster University" },
  { id: 22, name: "Leeds Beckett University" },
  { id: 23, name: "Liverpool John Moores University" },
  { id: 24, name: "Liverpool School of Tropical Medicine" },
  { id: 25, name: "London Business School" },
  { id: 26, name: "London School of Economics" },
  { id: 27, name: "London School of Hygiene & Tropical Medicine" },
  { id: 28, name: "Loughborough University" },
  { id: 29, name: "Newcastle University" },
  { id: 30, name: "Northumbria University" },
  { id: 31, name: "Nottingham Trent University" },
  { id: 32, name: "Oxford Brookes University" },
  { id: 33, name: "Queen Mary University of London" },
  { id: 34, name: "Queen’s University Belfast" },
  { id: 35, name: "Roehampton University" },
  { id: 36, name: "Royal Holloway University of London" },
  { id: 37, name: "Royal Veterinary College" },
  { id: 38, name: "Sheffield Hallam" },
  { id: 39, name: "St George’s, University of London" },
  { id: 40, name: "Swansea University" },
  { id: 41, name: "The University of Edinburgh" },
  { id: 42, name: "University College London (UCL)" },
  { id: 43, name: "University of Aberdeen" },
  { id: 44, name: "University of Bath" },
  { id: 45, name: "University of Birmingham" },
  { id: 46, name: "University of Bradford" },
  { id: 47, name: "University of Brighton" },
  { id: 48, name: "University of Bristol" },
  { id: 49, name: "University of Cambridge" },
  { id: 50, name: "University of Central Lancashire" },
  { id: 51, name: "University of Derby" },
  { id: 52, name: "University of Dundee" },
  { id: 53, name: "University of East Anglia" },
  { id: 54, name: "University of Essex" },
  { id: 55, name: "University of Exeter" },
  { id: 56, name: "University of Glasgow" },
  { id: 57, name: "University of Greenwich" },
  { id: 58, name: "University of Hertfordshire" },
  { id: 59, name: "University of Huddersfield" },
  { id: 60, name: "University of Hull" },
  { id: 61, name: "University of Kent" },
  { id: 62, name: "University of Leeds" },
  { id: 63, name: "University of Leicester" },
  { id: 64, name: "University of Lincoln" },
  { id: 65, name: "University of Liverpool" },
  { id: 366, name: "University of Stuttgart" },
  { id: 367, name: "Humboldt University of Berlin" },
  { id: 368, name: "Johannes Gutenberg University of Mainz" },
  { id: 369, name: "Philipps University of Marburg" },
  { id: 370, name: "RWTH Aachen University" },
  { id: 371, name: "Saarland University" },
  { id: 372, name: "TU Darmstadt" },
  { id: 373, name: "University of Bonn" },
  { id: 374, name: "University of Bremen" },
  { id: 375, name: "University of Duisburg-Essen" },
  { id: 376, name: "University of Erlangen-Nuremberg" },
  { id: 377, name: "University of Hamburg" },
  { id: 378, name: "University of Kassel" },
  { id: 379, name: "University of Osnabrück" },
  { id: 380, name: "University of Potsdam" },
  { id: 381, name: "University of Siegen" },
  { id: 382, name: "Carl von Ossietzky University Oldenburg" },
  { id: 383, name: "Constructor University" },
  { id: 384, name: "EBS Universität" },
  { id: 385, name: "ESMT Berlin" },
  { id: 386, name: "Frankfurt School of Finance & Management" },
  { id: 387, name: "Mannheim Business School" },
  {
    id: 66,
    name: "University of London School Oriental and African Studies (SOAS)"
  },
  { id: 67, name: "University of Nottingham" },
  { id: 68, name: "University of Oxford" },
  { id: 69, name: "University of Portsmouth" },
  { id: 70, name: "University of Reading" },
  { id: 3, name: "University of Sheffield" },
  { id: 72, name: "University of Southampton" },
  { id: 73, name: "University of St Andrews" },
  { id: 74, name: "University of Stirling" },
  { id: 75, name: "University of Strathclyde" },
  { id: 76, name: "University of Surrey" },
  { id: 77, name: "University of Sussex" },
  { id: 78, name: "University of the West of England" },
  { id: 79, name: "University of the West of Scotland" },
  { id: 80, name: "University of Ulster" },
  { id: 81, name: "University of Warwick" },
  { id: 82, name: "University of Westminster" },
  { id: 83, name: "University of Wolverhampton" },
  { id: 84, name: "University of York" },
  { id: 1, name: "Brock University" },
  { id: 2, name: "Carleton University" },
  { id: 3, name: "Dalhousie University" },
  { id: 4, name: "Lakehead University" },
  { id: 5, name: "McMaster University" },
  { id: 27, name: "Memorial University Of Newfoundland" },
  { id: 6, name: "New York Institute of Technology (NYIT)" },
  { id: 7, name: "Northeastern University" },
  { id: 8, name: "Queens University at Kingston" },
  { id: 9, name: "Ryerson University" },
  { id: 10, name: "Trent University" },
  { id: 11, name: "Toronto Metropolitan University" },
  { id: 12, name: "University of Alberta" },
  { id: 13, name: "University of Calgary" },
  { id: 14, name: "University of Guelph" },
  { id: 15, name: "University of Lethbridge" },
  { id: 16, name: "University of Ottawa" },
  { id: 17, name: "University of Toronto" },
  { id: 18, name: "University of Victoria" },
  { id: 19, name: "University of Waterloo" },
  { id: 20, name: "University of Windsor" },
  { id: 21, name: "Western University – University of Western Ontario" },
  { id: 22, name: "Wilfrid Laurier University" },
  { id: 23, name: "York University" },
  { id: 24, name: "University of New Brunswick" },
  { id: 25, name: "University of Saskatchewan" },
  { id: 26, name: "University of Manitoba" },
  { id: 2, name: "Ecole de Technologie Superieure" },
  { id: 4, name: "Laurentian University" },
  { id: 5, name: "McGill University" },
  { id: 7, name: "Ontario Tech University" },
  { id: 8, name: "Simon Fraser University" },
  { id: 11, name: "University of British Columbia" },
  { id: 15, name: "University of Montreal" },
  { id: 16, name: "University of Sherbrooke" },
  { id: 21, name: "Western University" },
  { id: 1, name: "Achievers University, Owo" },
  { id: 2, name: "Adeleke University, Ede" },
  { id: 3, name: "Afe Babalola University, Ado-Ekiti – Ekiti State" },
  { id: 4, name: "African University of Science & Technology, Abuja" },
  { id: 5, name: "Ahman Pategi University, Kwara State" },
  { id: 6, name: "Ajayi Crowther University, Ibadan" },
  { id: 7, name: "Al-Ansar University, Maiduguri, Borno" },
  { id: 8, name: "Al-Bayan University, Ankpa, Kogi State" },
  { id: 9, name: "Al-Hikmah University, Ilorin" },
  { id: 10, name: "Al-Istiqama University, Sumaila, Kano State" },
  { id: 11, name: "Al-Muhibbah Open University, Abuja" },
  { id: 12, name: "Al-Qalam University, Katsina" },
  { id: 13, name: "Aletheia University, Ago-Iwoye Ogun State" },
  { id: 14, name: "Amadeus University, Amizi, Abia State" },
  { id: 15, name: "Amaj University, Kwali, Abuja" },
  { id: 16, name: "American University of Nigeria, Yola" },
  { id: 17, name: "Anan University, Kwall, Plateau State" },
  { id: 18, name: "Anchor University Ayobo Lagos State" },
  { id: 19, name: "Arthur Javis University Akpoyubo Cross river State" },
  { id: 20, name: "Atiba University Oyo" },
  { id: 21, name: "Augustine University" },
  { id: 22, name: "Ave Maria University, Piyanko, Nasarawa State" },
  { id: 23, name: "Azman University, Kano State" },
  { id: 24, name: "Baba Ahmed University, Kano State" },
  { id: 25, name: "Babcock University, Ilishan-Remo" },
  { id: 26, name: "Baze University" },
  { id: 27, name: "Bells University of Technology, Otta" },
  { id: 28, name: "Benson Idahosa University, Benin City" },
  { id: 29, name: "Bingham University, New Karu" },
  { id: 30, name: "Bowen University, Iwo" },
  { id: 31, name: "British Canadian University, Obufu Cross River State" },
  { id: 32, name: "Caleb University, Lagos" },
  { id: 33, name: "Canadian University of Nigeria, Abuja" },
  { id: 34, name: "Capital City University, Kano State" },
  { id: 35, name: "Caritas University, Enugu" },
  { id: 36, name: "Chrisland University" },
  { id: 37, name: "Christopher University Mowe" },
  { id: 38, name: "Claretian University of Nigeria, Nekede, Imo State" },
  { id: 39, name: "Clifford University Owerrinta Abia State" },
  { id: 40, name: "Coal City University Enugu State" },
  { id: 41, name: "College of Petroleum and Energy Studies, Kaduna State" },
  { id: 42, name: "Cosmopolitan University Abuja" },
  { id: 43, name: "Covenant University Ota" },
  { id: 44, name: "Crawford University Igbesa" },
  { id: 45, name: "Crescent University" },
  { id: 46, name: "Dominican University Ibadan Oyo State" },
  { id: 47, name: "Dominion University Ibadan, Oyo State" },
  { id: 48, name: "Edusoko University, Bida, Niger State" },
  { id: 49, name: "Edwin Clark University, Kaigbodo" },
  {
    id: 50,
    name: "Eko University of Medical and Health Sciences Ijanikin, Lagos",
  },
  { id: 51, name: "El-Amin University, Minna, Niger State" },
  { id: 52, name: "Elizade University, Ilara-Mokin" },
  { id: 53, name: "Elrazi Medical University Yargaya University, Kano State" },
  { id: 54, name: "European University of Nigeria, Duboyi, FCT" },
  { id: 55, name: "Evangel University, Akaeze" },
  { id: 56, name: "Fountain Unveristy, Oshogbo" },
  { id: 57, name: "Franco British International University, Kaduna State" },
  {
    id: 58,
    name: "Gerar University of Medical Science Imope Ijebu, Ogun State.",
  },
  { id: 59, name: "Glorious Vision University, Ogwa, Edo State." },
  { id: 60, name: "Godfrey Okoye University, Ugwuomu-Nike – Enugu State" },
  { id: 61, name: "Iconic Open University, Sokoto State." },
  { id: 62, name: "Igbinedion University Okada" },
  { id: 63, name: "James Hope University, Lagos, Lagos State" },
  { id: 64, name: "Jewel University, Gombe state" },
  { id: 65, name: "Joseph Ayo Babalola University, Ikeji-Arakeji" },
  { id: 66, name: "Karl-Kumm University, Vom, Plateau State" },
  { id: 67, name: "Khadija University, Majia, Jigawa State" },
  { id: 68, name: "Khalifa Isiyaku Rabiu University, Kano" },
  { id: 69, name: "Kings University, Ode Omu" },
  { id: 70, name: "Kola Daisi University Ibadan, Oyo State" },
  { id: 3, name: "Kwararafa University, Wukari" },
  { id: 72, name: "Landmark University, Omu-Aran." },
  { id: 73, name: "Lead City University, Ibadan" },
  { id: 74, name: "Legacy University, Okija Anambra State" },
  { id: 75, name: "Lux Mundi University Umuahia, Abia State" },
  { id: 76, name: "Madonna University, Okija" },
  { id: 77, name: "Maduka University, Ekwegbe, Enugu State" },
  { id: 78, name: "Maranathan University, Mgbidi, Imo State" },
  { id: 79, name: "Margaret Lawrence University, Umunede, Delta State" },
  { id: 80, name: "Maryam Abacha American University of Nigeria, Kano State" },
  { id: 81, name: "Mcpherson University, Seriki Sotayo, Ajebo" },
  { id: 82, name: "Mercy Medical University, Iwo, Ogun State" },
  { id: 83, name: "Mewar International University, Masaka, Nasarawa State" },
  { id: 84, name: "Micheal & Cecilia Ibru University" },
  { id: 85, name: "Miva Open University, Abuja FCT" },
  { id: 86, name: "Mountain Top University" },
  { id: 87, name: "Mudiame University, Irrua, Edo State" },
  { id: 88, name: "Muhammad Kamalud University Kwara" },
  { id: 89, name: "Newgate University, MInna, Niger State." },
  { id: 90, name: "Nigerian British University, Asa, Abia State" },
  {
    id: 91,
    name: "Nigerian University of Technology and Management, Apapa, Lagos State",
  },
  { id: 92, name: "Nile University of Nigeria, Abuja" },
  { id: 93, name: "NOK University, Kachia, Kaduna State" },
  { id: 94, name: "NorthWest University Sokoto State" },
  { id: 95, name: "Novena University, Ogume" },
  { id: 96, name: "Obong University, Obong Ntak" },
  { id: 97, name: "Oduduwa University, Ipetumodu – Osun State" },
  { id: 98, name: "Ojaja University Eiyenkorin, Kwara State" },
  { id: 99, name: "PAMO University of Medical Sciences, Portharcourt" },
  { id: 100, name: "Pan-Atlantic University, Lagos" },
  { id: 101, name: "Paul University, Awka – Anambra State" },
  { id: 102, name: "PeaceLand University, Enugu State" },
  { id: 103, name: "PEN Resource University, Gombe" },
  { id: 104, name: "Peter University, Achina-Onneh Anambra State" },
  { id: 105, name: "Philomath University, Kuje, Abuja" },
  { id: 106, name: "Phoenix University, Agwada, Nasarawa State" },
  { id: 107, name: "Precious Cornerstone University, Oyo" },
  { id: 108, name: "Prime University, Kuje, FCT Abuja" },
  { id: 109, name: "Rayhaan University, Kebbi" },
  { id: 110, name: "Redeemer’s University, Ede" },
  { id: 111, name: "Renaissance University, Enugu" },
  { id: 112, name: "Rhema University, Obeama-Asa – Rivers State" },
  { id: 113, name: "Ritman University, Ikot Ekpene, Akwa Ibom" },
  {
    id: 114,
    name: "Saisa University of Medical Sciences and Technology, Sokoto State",
  },
  { id: 115, name: "Salem University, Lokoja" },
  { id: 116, name: "Sam Maris University, Ondo" },
  { id: 117, name: "Shanahan University Onitsha, Anambra State" },
  { id: 118, name: "Skyline University, Kano" },
  { id: 119, name: "Southwestern University, Oku Owa" },
  { id: 120, name: "Spiritan University, Nneochi Abia State" },
  { id: 121, name: "Sports University, Idumuje, Ugboko, Delta State" },
  { id: 122, name: "Summit University, Offa" },
  { id: 123, name: "Tansian University, Umunya" },
  { id: 124, name: "The Duke Medical University, Calabar, Cross River State" },
  { id: 125, name: "Thomas Adewumi University, Oko-Irese, Kwara State" },
  { id: 126, name: "Topfaith University, Mkpatak, Akwa Ibom State" },
  { id: 127, name: "Trinity University Ogun State" },
  { id: 128, name: "University of Mkar, Mkar" },
  { id: 129, name: "University of Offa, Kwara State" },
  { id: 130, name: "University on the Niger, Umunya, Anambra state" },
  { id: 131, name: "Venite University, Iloro-Ekiti, Ekiti State" },
  { id: 132, name: "Veritas University, Abuja" },
  { id: 133, name: "Vision University, Ikogbo, Ogun State" },
  { id: 134, name: "Wellspring University, Evbuobanosa – Edo State" },
  { id: 135, name: "Wesley University Ondo" },
  { id: 136, name: "West Midlands Open University, Ibadan, Oyo State" },
  { id: 137, name: "Western Delta University, Oghara Delta State" },
  { id: 138, name: "Westland University Iwo, Osun State" },
  { id: 139, name: "Wigwe University, Isiokpo Rivers State" },
  { id: 1, name: "Association of Certified Fraud Examiners" },
  { id: 2, name: "British Council" },
  { id: 3, name: "CFA EXAMS (ALL LEVELS)" },
  { id: 4, name: "Cambridge IGCSE qualification" },
  {
    id: 5,
    name: "Certiﬁcation Edge/Vantage Certifications (SPHRI, aPHRi | PHRi | SPHRi CERTIFICATIONS)",
  },
  { id: 6, name: "Chartered Governance Institute" },
  { id: 7, name: "Chartered Institute of Bankers of Nigeria" },
  { id: 8, name: "Chartered Institute of Stockbrokers" },
  { id: 9, name: "Chartered Institute of Personnel Management of Nigeria" },
  { id: 10, name: "Chartered Insurance Institute Of Nigeria" },
  {
    id: 11,
    name: "Chartered institute for Securities and Investment (Global Financial Compliance)",
  },
  { id: 12, name: "Homeworks.NG for GRE Examination" },
  { id: 13, name: "Institute of Chartered Accountants of Nigeria" },
  {
    id: 15,
    name: "Simon Page College of Marketing for Chartered Institute of Marketing",
  },
  { id: 16, name: "Teachers Registration Council of Nigeria" },
  {
    id: 14,
    name: "OTHER PROFESSIONALS INSTITUTES, BODIES AND EXAMS NOT LISTED",
  },
  { id: 0, name: "Air Force Institute of Technology" },
  { id: 1, name: "Alabama A&M University" },
  { id: 2, name: "Alfred University" },
  { id: 3, name: "American University" },
  { id: 4, name: "Appalachian State University" },
  { id: 5, name: "Arizona State University" },
  { id: 6, name: "Auburn University" },
  { id: 7, name: "Augusta University" },
  { id: 8, name: "Babson College" },
  { id: 9, name: "Baylor College of Medicine" },
  { id: 10, name: "Baylor University" },
  { id: 11, name: "Belmont University" },
  { id: 12, name: "Bentley University" },
  { id: 13, name: "Binghamton University - SUNY" },
  { id: 14, name: "Boise State University" },
  { id: 15, name: "Boston College" },
  { id: 16, name: "Boston University" },
  { id: 17, name: "Bowie State University" },
  { id: 18, name: "Bowling Green State University" },
  { id: 19, name: "Brandeis University" },
  { id: 20, name: "Brigham Young University" },
  { id: 21, name: "California Institute of Technology" },
  { id: 22, name: "California State University - Long Beach" },
  { id: 23, name: "California State University - Northridge" },
  { id: 24, name: "Canisius University" },
  { id: 25, name: "Carnegie Mellon University" },
  { id: 26, name: "Case Western Reserve University" },
  { id: 27, name: "Central Michigan University" },
  { id: 28, name: "Chapman University" },
  { id: 29, name: "Claremont Graduate University" },
  { id: 30, name: "Clark Atlanta University" },
  { id: 31, name: "Clark University" },
  { id: 32, name: "Clarkson University" },
  { id: 33, name: "Clemson University" },
  { id: 34, name: "Cleveland State University" },
  { id: 35, name: "College of Charleston" },
  { id: 36, name: "College of William & Mary" },
  { id: 37, name: "Colorado School of Mines" },
  { id: 38, name: "Colorado School of Public Health" },
  { id: 39, name: "Colorado State University" },
  { id: 40, name: "Columbia University" },
  { id: 41, name: "Cornell University" },
  { id: 42, name: "CUNY - Baruch College" },
  { id: 43, name: "CUNY - City College" },
  { id: 44, name: "CUNY - John Jay College of Criminal Justice" },
  { id: 45, name: "CUNY - SPH" },
  { id: 46, name: "CUNY - The Graduate Center" },
  { id: 47, name: "Dakota State University" },
  { id: 48, name: "Dartmouth College" },
  { id: 49, name: "Delaware State University" },
  { id: 50, name: "DePaul University" },
  { id: 51, name: "Drexel University" },
  { id: 52, name: "Duke University" },
  { id: 53, name: "Duquesne University" },
  { id: 54, name: "East Carolina University" },
  { id: 55, name: "East Tennessee State University" },
  { id: 56, name: "Eastern Michigan University" },
  { id: 57, name: "Eastern Virginia Medical School" },
  { id: 58, name: "Embry-Riddle Aeronautical University" },
  { id: 59, name: "Emory University" },
  { id: 60, name: "Florida A&M University" },
  { id: 61, name: "Florida Atlantic University" },
  { id: 62, name: "Florida Institute of Technology" },
  { id: 63, name: "Florida International University" },
  { id: 64, name: "Florida State University" },
  { id: 65, name: "Fordham University" },
  { id: 66, name: "George Mason University" },
  { id: 67, name: "George Washington University" },
  { id: 68, name: "Georgetown University" },
  { id: 69, name: "Georgia Institute of Technology" },
  { id: 70, name: "Georgia Southern University" },
  { id: 3, name: "Georgia State University" },
  { id: 72, name: "Governors State University - University Park" },
  { id: 73, name: "Hampton University" },
  { id: 74, name: "Harvard University" },
  { id: 75, name: "Hofstra University" },
  { id: 76, name: "Howard University" },
  { id: 77, name: "Hult International Business School" },
  { id: 78, name: "Icahn School of Medicine at Mount Sinai" },
  { id: 79, name: "Illinois Institute of Technology" },
  { id: 80, name: "Indiana State University" },
  { id: 81, name: "Indiana University" },
  { id: 82, name: "Indiana University Indianapolis" },
  { id: 83, name: "Iowa State University" },
  { id: 84, name: "Jackson State University" },
  { id: 85, name: "John Carroll University" },
  { id: 86, name: "Johns Hopkins University" },
  { id: 87, name: "Kansas State University" },
  { id: 88, name: "Keck Graduate Institute" },
  { id: 89, name: "Kent State University" },
  { id: 90, name: "La Salle University" },
  { id: 91, name: "Lake Erie College of Osteopathic Medicine" },
  { id: 92, name: "Lamar University" },
  { id: 93, name: "Lawrence Technological University" },
  { id: 94, name: "Lehigh University" },
  { id: 95, name: "Lincoln Memorial University" },
  { id: 96, name: "Lipscomb University" },
  { id: 97, name: "Loma Linda University" },
  { id: 98, name: "Long Island University - Brooklyn" },
  { id: 99, name: "Louisiana State University" },
  { id: 100, name: "Louisiana State University - Baton Rouge" },
  { id: 101, name: "Louisiana State University - Shreveport" },
  { id: 102, name: "Louisiana Tech University" },
  { id: 103, name: "Loyola Marymount University" },
  { id: 104, name: "Loyola University Chicago" },
  { id: 105, name: "Loyola University Maryland" },
  { id: 106, name: "Marquette University" },
  { id: 107, name: "Massachusetts Institute of Technology" },
  { id: 108, name: "Medical College of Wisconsin" },
  { id: 109, name: "Medical University of South Carolina" },
  { id: 110, name: "Miami University" },
  { id: 111, name: "Michigan State University" },
  { id: 112, name: "Michigan Technological University" },
  { id: 113, name: "Middle Tennessee State University" },
  { id: 114, name: "Midwestern University" },
  { id: 115, name: "Millsaps College" },
  { id: 116, name: "Mississippi State University" },
  { id: 117, name: "Missouri University of Science & Technology" },
  { id: 118, name: "Montana State University" },
  { id: 119, name: "Morehouse College" },
  { id: 120, name: "Morgan State University" },
  { id: 121, name: "New Jersey Institute of Technology" },
  { id: 122, name: "New Mexico Institute of Mining & Technology" },
  { id: 123, name: "New Mexico State University" },
  { id: 124, name: "New York Medical College" },
  { id: 125, name: "New York University" },
  { id: 127, name: "North Carolina State University" },
  { id: 128, name: "North Dakota State University" },
  { id: 130, name: "Northern Arizona University" },
  { id: 131, name: "Northern Illinois University" },
  { id: 132, name: "Northwestern University" },
  { id: 133, name: "Nova Southeastern University" },
  { id: 134, name: "Oakland University Rochester" },
  { id: 135, name: "Ohio State University" },
  { id: 136, name: "Ohio University" },
  { id: 137, name: "Oklahoma State University" },
  { id: 138, name: "Old Dominion University" },
  { id: 139, name: "Oregon Health and Science University" },
  { id: 140, name: "Oregon State University" },
  { id: 141, name: "Pace University" },
  { id: 142, name: "Pacific Lutheran University" },
  { id: 143, name: "Pennsylvania State University" },
  { id: 144, name: "Pepperdine University" },
  { id: 145, name: "Portland State University" },
  { id: 146, name: "Prairie View A&M University" },
  { id: 147, name: "Princeton University" },
  { id: 148, name: "Purdue University" },
  { id: 149, name: "Quinnipiac University" },
  { id: 150, name: "Rensselaer Polytechnic Institute" },
  { id: 151, name: "Rice University" },
  { id: 152, name: "Rochester Institute of Technology" },
  { id: 153, name: "Rollins College" },
  { id: 154, name: "Rosalind Franklin University of Medicine and Science" },
  { id: 155, name: "Rush University" },
  { id: 156, name: "Rutgers University/The State University of New Jersey" },
  { id: 157, name: "Saint Louis University" },
  { id: 158, name: "San Diego State University" },
  { id: 159, name: "San Francisco State University" },
  { id: 160, name: "Santa Clara University" },
  { id: 161, name: "Seton Hall University" },
  { id: 162, name: "South Dakota School of Mines and Technology" },
  { id: 163, name: "South Dakota State University" },
  { id: 164, name: "Southern Illinois University - Carbondale" },
  { id: 165, name: "Southern Methodist University" },
  { id: 166, name: "St. John's University" },
  { id: 167, name: "Stanford University" },
  { id: 168, name: "Stevens Institute of Technology" },
  { id: 169, name: "Stony Brook University" },
  { id: 170, name: "Suffolk University" },
  { id: 171, name: "SUNY College of Environmental Science and Forestry" },
  { id: 172, name: "SUNY Downstate Health Sciences University" },
  { id: 173, name: "SUNY Polytechnic Institute" },
  { id: 174, name: "SUNY Upstate Medical University" },
  { id: 175, name: "Syracuse University" },
  { id: 176, name: "Temple University" },
  { id: 177, name: "Tennessee State University" },
  { id: 178, name: "Tennessee Technological University" },
  { id: 179, name: "Texas A&M University" },
  { id: 180, name: "Texas A&M University - Corpus Christi" },
  { id: 181, name: "Texas A&M University - Kingsville" },
  { id: 182, name: "Texas Christian University" },
  { id: 183, name: "Texas State University" },
  { id: 184, name: "Texas Tech University" },
  { id: 185, name: "The Catholic University of America" },
  { id: 186, name: "The New School" },
  { id: 187, name: "Thomas Jefferson University" },
  { id: 188, name: "Touro University California" },
  { id: 189, name: "Towson University" },
  { id: 190, name: "Tufts University" },
  { id: 191, name: "Tulane University" },
  { id: 192, name: "University at Albany (SUNY)" },
  { id: 193, name: "University at Buffalo" },
  { id: 194, name: "University of Akron" },
  { id: 195, name: "University of Alabama" },
  { id: 196, name: "University of Alabama at Birmingham" },
  { id: 197, name: "University of Alabama in Huntsville" },
  { id: 198, name: "University of Alaska - Fairbanks" },
  { id: 199, name: "University of Arizona" },
  { id: 200, name: "University of Arkansas" },
  { id: 201, name: "University of Arkansas - Little Rock" },
  { id: 202, name: "University of Bridgeport" },
  { id: 203, name: "University of California - Merced" },
  { id: 204, name: "University of California Berkeley" },
  { id: 205, name: "University of California Davis" },
  { id: 206, name: "University of California Irvine" },
  { id: 207, name: "University of California Los Angeles" },
  { id: 208, name: "University of California Riverside" },
  { id: 209, name: "University of California San Diego" },
  { id: 210, name: "University of California San Francisco" },
  { id: 211, name: "University of California Santa Barbara" },
  { id: 212, name: "University of California Santa Cruz" },
  { id: 213, name: "University of Central Florida" },
  { id: 214, name: "University of Chicago" },
  { id: 215, name: "University of Cincinnati" },
  { id: 216, name: "University of Colorado" },
  { id: 217, name: "University of Colorado - Boulder" },
  { id: 218, name: "University of Colorado - Colorado Springs" },
  { id: 219, name: "University of Colorado - Denver" },
  { id: 220, name: "University of Connecticut" },
  { id: 221, name: "University of Dayton" },
  { id: 222, name: "University of Delaware" },
  { id: 223, name: "University of Denver" },
  { id: 224, name: "University of Detroit Mercy" },
  { id: 225, name: "University of Florida" },
  { id: 226, name: "University of Georgia" },
  { id: 227, name: "University of Hawaii at Manoa" },
  { id: 228, name: "University of Houston" },
  { id: 229, name: "University of Idaho" },
  { id: 230, name: "University of Illinois at Chicago" },
  { id: 231, name: "University of Illinois Urbana-Champaign" },
  { id: 232, name: "University of Iowa" },
  { id: 233, name: "University of Kansas" },
  { id: 234, name: "University of Kansas Medical Center" },
  { id: 235, name: "University of Kentucky" },
  { id: 236, name: "University of Louisiana at Lafayette" },
  { id: 237, name: "University of Louisville" },
  { id: 238, name: "University of Maine" },
  { id: 239, name: "University of Maryland" },
  { id: 240, name: "University of Maryland Baltimore County" },
  { id: 241, name: "University of Massachusetts - Amherst" },
  { id: 242, name: "University of Massachusetts - Boston" },
  { id: 243, name: "University of Massachusetts - Dartmouth" },
  { id: 244, name: "University of Massachusetts - Lowell" },
  { id: 245, name: "University of Memphis" },
  { id: 246, name: "University of Miami" },
  { id: 247, name: "University of Michigan" },
  { id: 248, name: "University of Michigan - Dearborn" },
  { id: 249, name: "University of Minnesota" },
  { id: 250, name: "University of Mississippi" },
  { id: 251, name: "University of Missouri" },
  { id: 252, name: "University of Missouri - Kansas City" },
  { id: 253, name: "University of Missouri - St. Louis" },
  { id: 254, name: "University of Montana" },
  { id: 255, name: "University of Nebraska" },
  { id: 256, name: "University of Nebraska - Lincoln" },
  { id: 257, name: "University of Nebraska - Omaha" },
  { id: 258, name: "University of Nevada - Las Vegas" },
  { id: 259, name: "University of Nevada - Reno" },
  { id: 260, name: "University of New Hampshire - Durham" },
  { id: 261, name: "University of New Haven" },
  { id: 262, name: "University of New Mexico" },
  { id: 263, name: "University of New Orleans" },
  { id: 264, name: "University of North Carolina - Chapel Hill" },
  { id: 265, name: "University of North Carolina - Charlotte" },
  { id: 266, name: "University of North Carolina - Greensboro" },
  { id: 267, name: "University of North Carolina - Wilmington" },
  { id: 268, name: "University of North Dakota" },
  { id: 269, name: "University of North Florida" },
  { id: 270, name: "University of North Texas" },
  { id: 271, name: "University of North Texas Health Science Center" },
  { id: 272, name: "University of Northern Colorado" },
  { id: 273, name: "University of Notre Dame" },
  { id: 274, name: "University of Oklahoma" },
  { id: 275, name: "University of Oklahoma Health Sciences Center" },
  { id: 276, name: "University of Oregon" },
  { id: 277, name: "University of Pennsylvania" },
  { id: 278, name: "University of Pittsburgh" },
  { id: 279, name: "University of Richmond" },
  { id: 280, name: "University of Rochester" },
  { id: 281, name: "University of San Diego" },
  { id: 282, name: "University of San Francisco" },
  { id: 283, name: "University of Scranton" },
  { id: 284, name: "University of South Alabama" },
  { id: 285, name: "University of South Carolina" },
  { id: 286, name: "University of South Dakota" },
  { id: 287, name: "University of South Florida" },
  { id: 288, name: "University of Southern California" },
  { id: 289, name: "University of Southern Mississippi" },
  { id: 290, name: "University of Tennessee - Chattanooga" },
  { id: 291, name: "University of Tennessee - Knoxville" },
  { id: 292, name: "University of Tennessee Health Science Center" },
  { id: 293, name: "University of Texas at Arlington" },
  { id: 294, name: "University of Texas at Austin" },
  { id: 295, name: "University of Texas at Dallas" },
  { id: 296, name: "University of Texas at El Paso" },
  { id: 297, name: "University of Texas at San Antonio" },
  { id: 298, name: "University of Texas Health Science Center at Houston" },
  { id: 299, name: "University of Texas Health Science Center at San Antonio" },
  { id: 300, name: "University of Texas Medical Branch" },
  { id: 301, name: "University of Texas Southwestern Medical Center" },
  { id: 302, name: "University of the Incarnate Word" },
  { id: 303, name: "University of Toledo" },
  { id: 304, name: "University of Tulsa" },
  { id: 305, name: "University of Utah" },
  { id: 306, name: "University of Virginia" },
  { id: 307, name: "University of Washington" },
  { id: 308, name: "University of Wisconsin - Milwaukee" },
  { id: 309, name: "University of Wisconsin-Madison" },
  { id: 310, name: "University of Wyoming" },
  { id: 311, name: "Utah State University" },
  { id: 312, name: "Vanderbilt University" },
  { id: 313, name: "Villanova University" },
  { id: 314, name: "Virginia Commonwealth University" },
  { id: 315, name: "Virginia Tech" },
  { id: 316, name: "Wake Forest University" },
  { id: 317, name: "Washington & Lee University" },
  { id: 318, name: "Washington State University" },
  { id: 319, name: "Washington University in St. Louis" },
  { id: 320, name: "Wayne State University" },
  { id: 321, name: "Wesleyan University" },
  { id: 322, name: "West Virginia University" },
  { id: 323, name: "Western Michigan University" },
  { id: 324, name: "Western University of Health Sciences" },
  { id: 325, name: "Wichita State University" },
  { id: 326, name: "Willamette University" },
  { id: 327, name: "Worcester Polytechnic Institute" },
  { id: 328, name: "Wright State University" },
  { id: 329, name: "Yale University" },
  { id: 330, name: "Yeshiva University" },
  { id: 331, name: "Erasmus University" },
  { id: 332, name: "Maastricht University" },
  { id: 333, name: "Nyenrode Business Universiteit" },
  { id: 334, name: "Tias Business School" },
  { id: 335, name: "University of Amsterdam" },
  { id: 336, name: "University of Groningen" },
  { id: 337, name: "University of Twente" },
  { id: 338, name: "Delft University of Technology" },
  { id: 339, name: "A. T. Still University of Health Sciences" },
  { id: 340, name: "Adelphi University" },
  { id: 341, name: "Albany College of Pharmacy and Health Sciences" },
  { id: 342, name: "Albany Medical College" },
  { id: 343, name: "Allen College" },
  { id: 345, name: "American University of Antigua (AUA) College of Medicine" },
  { id: 346, name: "Amherst College" },
  { id: 348, name: "Arcadia University" },
  { id: 350, name: "Arizona State University- Downtown Phoenix" },
  { id: 351, name: "Arizona State University- Polytechnic" },
  { id: 352, name: "Arizona State University- Skysong" },
  { id: 353, name: "Arizona State University- West" },
  { id: 356, name: "Ball State University" },
  { id: 357, name: "Barnard College" },
  { id: 358, name: "Baruch College of the City University of New York" },
  { id: 359, name: "Bates College" },
  { id: 362, name: "Bellin College" },
  { id: 365, name: "Berry College" },
  { id: 366, name: "Biola University" },
  { id: 367, name: "Bon Secours Memorial College of Nursing" },
  { id: 370, name: "Bowdoin College" },
  { id: 371, name: "Bradley University" },
  { id: 373, name: "Brigham Young University – Provo | BYU" },
  { id: 374, name: "Brown University" },
  { id: 375, name: "Bryan College of Health Sciences" },
  { id: 376, name: "Bryant University" },
  { id: 377, name: "Bryn Mawr College" },
  { id: 378, name: "Bucknell University" },
  { id: 379, name: "Butler University" },
  {
    id: 381,
    name: "California State University Maritime Academy (Cal Maritime)",
  },
  {
    id: 382,
    name: "California Polytechnic State University-San Luis Obispo – Cal Poly",
  },
  { id: 383, name: "California State University – Long Beach" },
  { id: 384, name: "California State University – Los Angeles" },
  { id: 385, name: "California State University – San Bernardino" },
  { id: 386, name: "California State University – Northridge" },
  { id: 387, name: "Calvin College" },
  { id: 388, name: "Carleton College" },
  { id: 391, name: "Catholic University of America" },
  { id: 392, name: "Centra College of Nursing" },
  { id: 394, name: "Centre College" },
  { id: 396, name: "Chatham University" },
  { id: 397, name: "City College of New York – University of New York" },
  { id: 399, name: "Claremont McKenna College" },
  { id: 401, name: "Clarkson College" },
  { id: 404, name: "Colby College" },
  { id: 405, name: "Colgate University" },
  { id: 407, name: "College of the Holy Cross" },
  { id: 408, name: "College of William and Mary" },
  { id: 409, name: "Colorado College" },
  { id: 411, name: "Colorado State University-Fort Collins" },
  { id: 413, name: "Connecticut College" },
  { id: 414, name: "Cooper Union for the Advancement of Science and Art" },
  { id: 416, name: "Creighton University" },
  { id: 418, name: "Davidson College" },
  { id: 419, name: "Denison University" },
  { id: 420, name: "Denver College of Nursing" },
  { id: 422, name: "DePauw University" },
  { id: 423, name: "Des Moines University – Osteopathic Medical Center" },
  { id: 424, name: "DeSales University" },
  { id: 425, name: "Dickinson College" },
  { id: 426, name: "Dordt College" },
  { id: 427, name: "Drake University" },
  { id: 432, name: "Edgewood College" },
  { id: 433, name: "Elon University" },
  { id: 434, name: "Emerson College" },
  { id: 436, name: "Fairfield University" },
  { id: 439, name: "Florida State University - FSU" },

  { id: 102, name: "Franciscan Missionaries of Our Lady University" },
  { id: 103, name: "Franklin and Marshall College" },
  { id: 104, name: "Frontier Nursing University" },
  { id: 105, name: "Furman University" },
  { id: 106, name: "Gannon University" },
  { id: 108, name: "George Washington University – GWU" },
  { id: 110, name: "Georgia Institute of Technology – Georgia Tech" },
  { id: 111, name: "Gettysburg College" },
  { id: 112, name: "Goldfarb School of Nursing at Barnes-Jewish College" },
  { id: 113, name: "Gonzaga University" },
  { id: 114, name: "Grand Valley State University" },
  { id: 115, name: "Grinnell College" },
  { id: 116, name: "Hamilton College" },
  { id: 118, name: "Harvey Mudd College" },
  { id: 119, name: "Haverford College" },
  { id: 120, name: "High Point University" },
  { id: 124, name: "Illinois Wesleyan University" },
  { id: 125, name: "Indiana University – Bloomington" },
  { id: 126, name: "Indiana University School of Medicine" },
  { id: 127, name: "Ithaca College" },
  { id: 130, name: "Kalamazoo College" },
  { id: 131, name: "Kansas City University" },
  { id: 132, name: "Kenyon College" },
  { id: 133, name: "King’s College – Pennsylvania" },
  { id: 134, name: "Knox College" },
  { id: 135, name: "Lake Forest College" },
  { id: 137, name: "LaSalle University" },
  { id: 138, name: "Lawrence University" },
  { id: 139, name: "Le Moyne College" },
  { id: 141, name: "Lewis University" },
  { id: 142, name: "LIM College" },
  { id: 143, name: "Lindenwood University" },
  { id: 147, name: "Loyola University New Orleans" },
  { id: 148, name: "Lynn University" },
  { id: 149, name: "Macalester College" },
  { id: 150, name: "Marian University" },
  { id: 151, name: "Marist College" },
  { id: 153, name: "Maryville University" },
  { id: 154, name: "Massachusetts Institute of Technology – MIT" },
  { id: 155, name: "McDaniel College" },
  { id: 158, name: "Meharry Medical College" },
  { id: 159, name: "Messiah College" },
  { id: 162, name: "Middlebury College" },
  { id: 163, name: "Mills College" },
  { id: 164, name: "Minnesota State University" },
  { id: 165, name: "Missouri University of Science and Technology" },
  { id: 166, name: "Monmouth University" },
  { id: 167, name: "Mount Holyoke College" },
  { id: 168, name: "Mount St. Joseph University" },
  { id: 169, name: "Mount St. Mary's University" },
  { id: 170, name: "Muhlenberg College" },
  { id: 172, name: "New York University - NYU" },
  { id: 174, name: "North Carolina Central University" },
  { id: 175, name: "North Central College" },
  { id: 178, name: "Northern Michigan University" },
  { id: 180, name: "Notre Dame de Namur University" },
  { id: 181, name: "Oberlin College" },
  { id: 182, name: "Occidental College" },
  { id: 183, name: "Ohio Northern University" },
  { id: 185, name: "Ohio Wesleyan University" },
  { id: 186, name: "Oregon Health & Science University" },
  { id: 188, name: "Otis College of Art and Design" },
  { id: 189, name: "Our Lady of the Lake University" },
  { id: 192, name: "Pacific Union College" },
  { id: 193, name: "Pennsylvania State University - Penn State" },
  { id: 195, name: "Philadelphia College of Osteopathic Medicine" },
  { id: 196, name: "Pitzer College" },
  { id: 197, name: "Pomona College" },
  { id: 199, name: "Providence College" },
  { id: 203, name: "Research College of Nursing" },
  { id: 204, name: "Rhodes College" },
  { id: 206, name: "Robert Morris University" },
  { id: 210, name: "Roseman University of Health Sciences" },
  { id: 211, name: "Rowan University" },
  { id: 213, name: "Rutgers University" },
  { id: 214, name: "Saint Francis Medical Center College of Nursing" },
  { id: 215, name: "Saint Francis University" },
  { id: 216, name: "Saint John Fisher College" },
  { id: 217, name: "Saint Louis University-Main Campus" },
  { id: 218, name: "Saint Lukes College of Health Sciences" },
  { id: 219, name: "Saint Mary's College of California" },
  { id: 220, name: "Samford University" },
  { id: 221, name: "Samuel Merritt University" },
  { id: 222, name: "San Diego State University – SDSU" },
  { id: 224, name: "Scripps College" },
  { id: 225, name: "Seattle Pacific University" },
  { id: 226, name: "Seattle University" },
  { id: 227, name: "Sentara College of Health Sciences" },
  { id: 228, name: "Seton Hall University - New Jersey" },
  { id: 229, name: "Seton Hill University - Pennsylvania" },
  { id: 230, name: "Sewanee - The University of the South" },
  { id: 231, name: "Shenandoah University" },
  { id: 232, name: "Simmons College" },
  { id: 233, name: "Skidmore College" },
  { id: 234, name: "Smith College" },
  { id: 235, name: "Soka University of America" },
  { id: 238, name: "Southern Methodist University - SMU" },
  {
    id: 239,
    name: "St. James School of Medicine | Saint James School of Medicine",
  },
  { id: 240, name: "St. John's University - New York" },
  { id: 241, name: "St. Louis College of Pharmacy" },
  { id: 242, name: "St. Lukes College" },
  { id: 244, name: "Stetson University" },
  { id: 246, name: "Stonehill College" },
  { id: 248, name: "SUNY at Albany" },
  { id: 249, name: "SUNY at Binghamton" },
  { id: 250, name: "SUNY at Stony Brook" },
  { id: 252, name: "SUNY Downstate Medical Center" },
  { id: 253, name: "Swarthmore College" },
  { id: 255, name: "Taylor University" },
  { id: 256, name: "Teachers College at Columbia University" },
  { id: 259, name: "Texas Christian University - TCU" },
  { id: 260, name: "Texas Tech University - Main Campus" },
  { id: 261, name: "Texas Tech University Health Sciences Center" },
  { id: 262, name: "The Citadel" },
  { id: 263, name: "The College of New Jersey" },
  { id: 265, name: "The University of Alabama" },
  { id: 266, name: "The University of Texas at Dallas" },
  { id: 267, name: "The University of Texas Health Science - San Antonio" },
  { id: 268, name: "The University of Texas Health Science Center at Houston" },
  { id: 269, name: "The University of Texas MD Anderson Cancer Center" },
  { id: 270, name: "The University of Texas Medical Branch" },
  { id: 271, name: "The University of Texas Rio Grande Valley" },
  { id: 272, name: "The University of Virginia College at Wise" },
  { id: 273, name: "Thomas Aquinas College" },
  { id: 275, name: "Thunderbird School of Global Management" },
  { id: 276, name: "Touro University" },
  { id: 278, name: "Trinity College" },
  { id: 279, name: "Trinity University" },
  { id: 280, name: "Truman State University" },
  { id: 283, name: "Union College (New York)" },
  { id: 284, name: "Union University" },
  { id: 285, name: "United States Merchant Marine Academy" },
  { id: 289, name: "University of Arkansas Fayetteville" },
  { id: 290, name: "University of Arkansas for Medical Sciences" },
  { id: 291, name: "University of California – Berkeley" },
  { id: 292, name: "University of California – Davis" },
  { id: 293, name: "University of California – Irvine" },
  { id: 294, name: "University of California – Los Angeles – UCLA" },
  { id: 295, name: "University of California – Merced" },
  { id: 296, name: "University of California – Riverside" },
  { id: 297, name: "University of California – San Diego – UCSD" },
  { id: 298, name: "University of California – San Francisco – UCSF" },
  { id: 299, name: "University of California – Santa Barbara – UCSB" },
  { id: 300, name: "University of California – Santa Cruz" },
  { id: 301, name: "University of California College of Law" },

  { id: 149, name: "University of Chicago (incl. Booth)" },
  { id: 151, name: "University of Colorado at Boulder" },
  { id: 152, name: "University of Colorado at Colorado Springs" },
  { id: 153, name: "University of Colorado Denver" },
  { id: 154, name: "University of Connecticut – Uconn" },
  { id: 161, name: "University of Hartford" },
  { id: 163, name: "University of Health Sciences and Pharmacy in St Louis" },
  { id: 167, name: "University of Illinois at Urbana-Champaign" },
  { id: 171, name: "University of La Verne" },
  { id: 174, name: "University of Maryland – Baltimore" },
  { id: 175, name: "University of Maryland – Baltimore County" },
  { id: 176, name: "University of Maryland – College Park" },
  { id: 177, name: "University of Massachusetts – Lowell" },
  { id: 178, name: "University of Massachusetts Amherst – UMass Amherst" },
  { id: 180, name: "University of Massachusetts Medical School (UMMS)" },
  { id: 182, name: "University of Michigan – Ann Arbor" },
  { id: 183, name: "University of Minnesota – Twin Cities" },
  { id: 184, name: "University of Missouri – Columbia" },
  { id: 185, name: "University of Missouri – Kansas City" },
  { id: 186, name: "University of Mount Union" },
  { id: 187, name: "University of Nebraska – Lincoln" },
  { id: 188, name: "University of Nebraska Medical Center" },
  { id: 189, name: "University of New England" },
  { id: 190, name: "University of New Hampshire" },
  { id: 192, name: "University of North Carolina – Wilmington" },
  { id: 193, name: "University of North Carolina at Chapel Hill – UNC" },
  {
    id: 195,
    name: "University of North Texas Health Science Center at Fort Worth",
  },
  { id: 196, name: "University of Northern Iowa" },
  { id: 200, name: "University of Pennsylvania (including Wharton)" },
  { id: 202, name: "University of Portland" },
  { id: 203, name: "University of Puerto Rico-Medical Sciences" },
  { id: 204, name: "University of Rhode Island" },
  { id: 207, name: "University of Saint Joseph" },
  { id: 208, name: "University of San Diego – USD" },
  { id: 211, name: "University of South Carolina – Columbia" },
  { id: 214, name: "University of Southern California – USC" },
  { id: 215, name: "University of St. Thomas" },
  { id: 216, name: "University of Tennessee – Knoxville" },
  { id: 217, name: "University of Texas at Austin – UT Austin" },
  {
    id: 218,
    name: "University of Texas Southwestern Medical Center at Dallas",
  },
  { id: 219, name: "University of the Pacific" },
  { id: 220, name: "University of the Potomac" },
  { id: 221, name: "University of the Sciences" },
  { id: 224, name: "University of Vermont" },
  { id: 226, name: "University of Washington- Seattle" },
  { id: 227, name: "University of Wisconsin – Madison" },
  { id: 229, name: "Utah College of Dental Hygiene" },
  { id: 230, name: "Valparaiso University" },
  { id: 232, name: "Vassar College" },
  { id: 235, name: "Virginia Polytechnic Institute and State University" },
  { id: 237, name: "Washington and Lee University" },
  { id: 239, name: "Washington University in St Louis" },
  { id: 240, name: "Wellesley College" },
  { id: 243, name: "Western Washington University" },
  { id: 244, name: "Whitman College" },
  { id: 245, name: "Whitworth University" },
  { id: 295, name: "Widener University – Main Campus" },
  { id: 296, name: "William Jessup University" },
  { id: 297, name: "Williams College" },
  { id: 301, name: "Eindhoven University of Technology" },
  { id: 302, name: "Vrije Universiteit Amsterdam" },
  { id: 303, name: "University of Edinburgh" },
  { id: 304, name: "Utrecht University" },
  { id: 305, name: "Queens University" },
  { id: 307, name: "Leiden University" },
  { id: 308, name: "Montclair State University" },

  { id: 1, name: "The University of Tampa" },
  { id: 2, name: "Dominican University of California" },
  { id: 3, name: "East Carolina University" },
  { id: 4, name: "Marywood University" },
  { id: 5, name: "University of North Carolina at Charlotte" },
  { id: 6, name: "Arkansas State University" },
  { id: 7, name: "California Baptist University" },
  { id: 8, name: "California State University-San Marcos" },
  { id: 9, name: "Drew University" },
  { id: 10, name: "Lewis University" },
  { id: 11, name: "Sacred Heart University" },
  { id: 12, name: "San Jose State University" },
  { id: 13, name: "Texas State University" },
  { id: 14, name: "Webster University" },
  { id: 15, name: "Wilkes University" },
  { id: 16, name: "Andrews University" },
  { id: 17, name: "California Lutheran University" },
  { id: 18, name: "California State University-Fresno" },
  { id: 19, name: "California State University-Sacramento" },
  { id: 20, name: "D'Youville College" },
  { id: 21, name: "Embry-Riddle Aeronautical University-Prescott" },
  { id: 22, name: "Fitchburg State University" },
  { id: 23, name: "Lynn University" },
  { id: 24, name: "Minnesota State University-Mankato" },
  { id: 25, name: "Ohio University" },
  { id: 26, name: "Portland State University" },
  { id: 27, name: "Saint Joseph's University" },
  { id: 28, name: "San Francisco State University" },
  { id: 29, name: "Southern Illinois University-Edwardsville" },
  { id: 30, name: "State University of New York at New Paltz" },
  { id: 31, name: "University of Illinois Springfield" },
  { id: 32, name: "University of Nevada-Reno" },
  { id: 33, name: "University of North Florida" },
  { id: 34, name: "Utah State University" },
  { id: 35, name: "University of Michigan-Dearborn" },
  { id: 36, name: "University of North Texas" },
  { id: 37, name: "Wichita State University" },
  { id: 38, name: "Boise State University" },
  { id: 39, name: "Embry-Riddle Aeronautical University-Daytona Beach" },
  { id: 40, name: "Georgia Southern University" },
  { id: 41, name: "Louisiana Tech University" },
  { id: 42, name: "Northern Arizona University" },
  { id: 43, name: "Oakland University" },
  { id: 44, name: "The University of Texas at Arlington" },
  { id: 45, name: "University of Alabama in Huntsville" },
  { id: 46, name: "University of Missouri-St. Louis" },
  { id: 47, name: "University of North Carolina at Greensboro" },
  { id: 48, name: "University of the Incarnate Word" },
  { id: 49, name: "Wayne State University" },
  { id: 50, name: "California State University-Chico" },
  { id: 51, name: "Rutgers University-Camden" },
  { id: 52, name: "Azusa Pacific University" },
  { id: 53, name: "California State Polytechnic University-Pomona" },
  { id: 54, name: "Montana State University" },
  { id: 55, name: "Niagara University" },
  { id: 56, name: "Tennessee Technological University" },
  { id: 57, name: "The University of West Florida" },
  { id: 58, name: "Monroe University" },
  { id: 59, name: "Florida Institute of Technology" },
  { id: 60, name: "Lawrence Technological University" },
  { id: 61, name: "University of St. Thomas (Houston)" },
  { id: 62, name: "University of Washington-Bothell Campus" },
  { id: 63, name: "University of Washington-Tacoma Campus" },
  { id: 64, name: "Mercer University" },
  { id: 65, name: "University of Manchester" },
  { id: 66, name: "University of Plymouth" },
  { id: 67, name: "University of Salford" },
];

const schoolsWithUniqueIds = supportedSchools.map((school, index) => ({
  ...school,
  uniqueId: index + 1,
}));

// Remove duplicate school names
const uniqueSchools = [];
const seenNames = new Set();

for (const school of schoolsWithUniqueIds) {
  if (!seenNames.has(school.name)) {
    uniqueSchools.push(school);
    seenNames.add(school.name);
  }
}

export const sortedSchools = uniqueSchools.sort((a, b) =>
  a.name.localeCompare(b.name)
);

// OnBoarding Form
export const yesNoOptions = [
  {
    value: "true",
    label: "Yes",
  },
  {
    value: "false",
    label: "No",
  },
];

export const graduateOptions = [
  {
    value: "Polytechnic",
    label: "Polytechnic",
  },
  {
    value: "University",
    label: "University",
  },
];

export const membershipOptions = [
  {
    value: "NEW ONBOARDED CANDIDATE - UNADMITTED",
    label: "NEW ONBOARDED CANDIDATE - UNADMITTED",
  },
  {
    value: "NEW ONBOARDED CANDIDATE - ADMITTED",
    label: "NEW ONBOARDED CANDIDATE - ADMITTED",
  },
  {
    value: "REPEAT CANDIDATE - ONE ADMISSION DENIED",
    label: "REPEAT CANDIDATE - ONE ADMISSION DENIED",
  },
  {
    value: "REPEAT CANDIDATE - TWO ADMISSIONS DENIED",
    label: "REPEAT CANDIDATE - TWO ADMISSIONS DENIED",
  },
];

export const degreeTypeOptions = [
  {
    value: "Bachelor of Science",
    label: "Bachelor of Science",
  },
  {
    value: "Bachelor of Education",
    label: "Bachelor of Education",
  },
  {
    value: "Bachelor of Law",
    label: "Bachelor of Law",
  },
  {
    value: "Bachelor of Engineering",
    label: "Bachelor of Engineering",
  },
  {
    value: "Bachelor of Medicine and Surgery",
    label: "Bachelor of Medicine and Surgery",
  },

  {
    value: "Bachelor of Dental Surgery",
    label: "Bachelor of Dental Surgery",
  },

  {
    value: "Bachelor of Pharmacy",
    label: "Bachelor of Pharmacy",
  },

  {
    value: "Bachelor of Nursing",
    label: "Bachelor of Nursing",
  },

  {
    value: "Bachelor of Medical Laboratory Science",
    label: "Bachelor of Medical Laboratory Science",
  },

  {
    value: "Higher National Diploma",
    label: "Higher National Diploma",
  },

  {
    value: "Bachelor of Arts",
    label: "Bachelor of Arts",
  },

  {
    value: "Bachelor of Technology",
    label: "Bachelor of Technology",
  },
  {
    value: "Bachelor of Agriculture",
    label: "Bachelor of Agriculture",
  },
  {
    value: "Doctor of Veterinary Medicine",
    label: "Doctor of Veterinary Medicine",
  },

  {
    value: "Doctor of Pharmacy",
    label: "Doctor of Pharmacy",
  },
];

export const advancedDegreeTypeOptions = [
  {
    value: "Master of Science (MSC)",
    label: "Master of Science (MSC)",
  },
  {
    value: "Master of Arts (MA)",
    label: "Master of Arts (MA)",
  },
  {
    value: "Master of Business Administration (MBA)",
    label: "Master of Business Administration (MBA)",
  },
  {
    value: "Master of Engineering (M.ENG)",
    label: "Master of Engineering (M.ENG)",
  },
  {
    value: "Master of Law (LLM)",
    label: "Master of Law (LLM)",
  },

  {
    value: "Master of Education (M.ED)",
    label: "Master of Education (M.ED)",
  },

  {
    value: "Master of Pharmacy",
    label: "Master of Pharmacy",
  },

  {
    value: "Master of Nursing",
    label: "Master of Nursing",
  },

  {
    value: "Master of Medical Laboratory Science",
    label: "Master of Medical Laboratory Science",
  },

  {
    value: "Master of Technology",
    label: "Master of Technology",
  },
];

export const classOfDegreeOptions = [
  {
    value: "First Class and below 32 years old – All 17 countries",
    label: "First Class and below 32 years old – All 17 countries",
  },
  {
    value:
      "First Class and above 32 years old – restricted to the U.S and Canada ",
    label:
      "First Class and above 32 years old – restricted to the U.S and Canada ",
  },
  {
    value: "Second Class Upper and below 32 years old – All 17 Countries",
    label: "Second Class Upper and below 32 years old – All 17 Countries",
  },

  {
    value:
      "Second Class Upper and above 32 years old - restricted to the U.S and Canada ",
    label:
      "Second Class Upper and above 32 years old - restricted to the U.S and Canada ",
  },

  {
    value:
      "Second Class Lower and below 32 years old – cannot apply to selected countries ",
    label:
      "Second Class Lower and below 32 years old – cannot apply to selected countries ",
  },

  {
    value:
      "Second Class Lower and above 32 years old – restricted only to the U.S ",
    label:
      "Second Class Lower and above 32 years old – restricted only to the U.S ",
  },

  {
    value:
      "Third Class and below 32 years old - restricted only to the U.S and U.K ",
    label:
      "Third Class and below 32 years old - restricted only to the U.S and U.K ",
  },

  {
    value: "Third Class and above 32 years old - restricted only to the U.S ",
    label: "Third Class and above 32 years old - restricted only to the U.S ",
  },

  {
    value: "Pass and below 32 years old – not eligible",
    label: "Pass and below 32 years old – not eligible",
  },

  {
    value: "Pass and above 32 years old – not eligible",
    label: "Pass and above 32 years old – not eligible",
  },
];

export const classOfDegreeMastersOptions = [
  {
    value: "First Class",
    label: "First Class",
  },
  {
    value: "Second Class Upper",
    label: "Second Class Upper",
  },
  {
    value: "Second Class Lower",
    label: "Second Class Lower",
  },
  {
    value: "Third Class",
    label: "Third Class",
  },
  {
    value: "Pass",
    label: "Pass",
  },
  {
    value: "Not Applicable",
    label: "Not Applicable",
  },
];

export const typeOfAcademicDegreeOptions = [
  {
    value: "MBA",
    label: "MBA",
  },
  {
    value: "MSc",
    label: "MSc",
  },
  {
    value: "MRes",
    label: "MRes",
  },
  {
    value: "LLM",
    label: "LLM",
  },
  {
    value: "MENG",
    label: "MENG",
  },
  {
    value: "MA",
    label: "MA",
  },
  {
    value: "Open to ANY Suitable Option recommended by the Team",
    label: "Open to ANY Suitable Option recommended by the Team",
  },
];

export const countriesOfInterestOptions = [
  {
    value: "United States",
    label: "United States",
  },
  {
    value: "United Kingdom",
    label: "United Kingdom",
  },
  {
    value: "Canada",
    label: "Canada",
  },
  {
    value: "Australia",
    label: "Australia",
  },
  {
    value: "Germany",
    label: "Germany",
  },
  {
    value: "France",
    label: "France",
  },
  {
    value: "Netherlands",
    label: "Netherlands",
  },
  {
    value: "Singapore",
    label: "Singapore",
  },
  {
    value: "Belgium",
    label: "Belgium",
  },
  {
    value: "Switzerland",
    label: "Switzerland",
  },
  {
    value: "South Africa",
    label: "South Africa",
  },
  {
    value: "Portugal",
    label: "Portugal",
  },
  {
    value: "China",
    label: "China",
  },
  {
    value: "Spain",
    label: "Spain",
  },
  {
    value: "Italy",
    label: "Italy",
  },
  {
    value: "Denmark",
    label: "Denmark",
  },
  {
    value: "Hong Kong",
    label: "Hong Kong",
  },
];
